import React from "react";
import ChartSectionCard from "./ChartSectionCard";
import ChartSkeleton from "./ChartSkeleton";
import TrendAreaChart from "./TrendAreaChart";

export default function ServicesTrendChart({
  data,
  loading,
  height = 200,
  cardSx,
}) {
  const chartData = (data || []).map((d) => ({
    label: d.label || `${d.monthName} ${d.year}`,
    count: d.count ?? 0,
  }));

  const total = chartData.reduce((s, d) => s + d.count, 0);
  const avg = chartData.length > 0 ? Math.round(total / chartData.length) : 0;

  return (
    <ChartSectionCard
      title="Tendencia de servicios"
      subtitle={loading ? "Cargando..." : `12 meses · Promedio ${avg}/mes`}
      sx={{ height: "100%", ...cardSx }}
    >
      {loading ? (
        <ChartSkeleton height={height} />
      ) : (
        <TrendAreaChart data={chartData} height={height} valueLabel=" servicios" />
      )}
    </ChartSectionCard>
  );
}
